// AUTO GENERATED FILE

import { ArrayCTA } from './components/ArrayCTA'
import { BasicHedgehogImage } from './components/BasicHedgehogImage'
import { BorderWrapper } from './components/BorderWrapper'
import { CallToAction } from './components/CallToAction'
import { Caption } from './components/Caption'
import CloudinaryImage from './components/CloudinaryImage'
import { Images } from './components/Careers/Images'
import { ComparisonTable } from './components/ComparisonTable'
import ProductComparisonTable from './components/ProductComparisonTable'
import Snippet from '../contents/docs/integrate/snippet.mdx'
import { CompensationCalculator } from './components/CompensationCalculator'
import { ContentViewer } from './components/ContentViewer'
import { Drawer } from './components/Drawer'
import { lib } from './components/Edition/lib'
import { Emoji } from './components/Emoji'
import { FeatureAvailability } from './components/FeatureAvailability'
import { FormulaScreenshot } from './components/FormulaScreenshot'
import { GDPRForm } from './components/GDPRForm'
import { HiddenSection } from './components/HiddenSection'
import { HubSpotForm } from './components/HubSpotForm'
import { KeyboardShortcut } from './components/KeyboardShortcut'
import { LPCTA } from './components/LPCTA'
import { Label } from './components/Label'
import { List } from './components/List'
import { OverflowXSection } from './components/OverflowXSection'
import { Quote } from './components/Pricing/Quote'
import Link from './components/Link'
import { PrivateLink } from './components/PrivateLink'
import ImageSlider from './components/ImageSlider'
import { ProductOS } from './components/Product/ProductOS'
import { ProductScreenshot } from './components/ProductScreenshot'
import { ProductVideo } from './components/ProductVideo'
import { Competitor } from './components/Products/Competitor'
import { DocsLinks } from './components/Products/DocsLinks'
import { FAQ } from './components/Products/FAQ'
import { Feature } from './components/Products/Feature'
import { Marquee } from './components/Products/Marquee'
import { MobileSlides } from './components/Products/MobileSlides'
import { OSQuote } from './components/OSQuote'
import { PairsWith } from './components/Products/PairsWith'
import { Question } from './components/Products/Question'
import { SmoothScroll } from './components/Products/SmoothScroll'
import { Subfeature } from './components/Products/Subfeature'
import { TextCard } from './components/Products/TextCard'
import { TutorialCard } from './components/Products/TutorialCard'
import { QuickLinks } from './components/QuickLinks'
import { Quote2 } from './components/Quote2'
import { Signatures } from './components/Signatures'
import { SlackPage } from './components/SlackPage'
import { Squeak } from './components/Squeak'
import { StarRepoButton } from './components/StarRepoButton'
import { TracksCTA } from './components/TracksCTA'
import { Tweet } from './components/Tweet'
import { ZendeskTicket } from './components/ZendeskTicket'
import { MaxCTA } from './components/MaxCTA'
import TeamMember from './components/TeamMember'
import SmallTeam from './components/SmallTeam'
import { Steps, Step } from './components/Docs/Steps'
import OSButton from './components/OSButton'
import AskMax from './components/AskMax'
import CountriesWeHireIn from './components/AMCharts/CountriesWeHireIn'
import FeatureOwnershipTable from './components/FeatureOwnershipTable'
import TaskOwnershipTable from './components/TaskOwnershipTable'

export const shortcodes = {
    ArrayCTA,
    BasicHedgehogImage,
    BorderWrapper,
    CallToAction,
    Caption,
    CloudinaryImage,
    Images,
    ImageSlider,
    ComparisonTable,
    ProductComparisonTable,
    Snippet,
    CompensationCalculator,
    ContentViewer,
    Drawer,
    lib,
    Emoji,
    FeatureAvailability,
    FormulaScreenshot,
    GDPRForm,
    HiddenSection,
    HubSpotForm,
    KeyboardShortcut,
    LPCTA,
    Label,
    List,
    OverflowXSection,
    Quote,
    OSQuote,
    OSButton,
    Link,
    PrivateLink,
    ProductOS,
    ProductScreenshot,
    ProductVideo,
    Competitor,
    DocsLinks,
    FAQ,
    Feature,
    Marquee,
    MobileSlides,
    PairsWith,
    Question,
    SmoothScroll,
    Subfeature,
    TextCard,
    TutorialCard,
    QuickLinks,
    Quote2,
    Signatures,
    SlackPage,
    Squeak,
    StarRepoButton,
    TracksCTA,
    Tweet,
    ZendeskTicket,
    MaxCTA,
    SmallTeam,
    TeamMember,
    Steps,
    Step,
    AskMax,
    CountriesWeHireIn,
    FeatureOwnershipTable,
    TaskOwnershipTable,
}
